import { ColumnSetupType } from "../../../../../../../../../../../../../../storybook/data-grid/utils/types/types";
import { S3 } from "../../../../../../../../../../../../../../services/cloudchipr.api";
import { ResourceMetricsHeaderCell } from "../../../../../cells/metrics-cells/components/ResourceMetricsHeaderCell";

export const s3Columns: ColumnSetupType<S3>[] = [
  {
    accessorKey: "provider_unique_identifier",
    header: "Buckets",
    type: "identifier",
    size: 320,
    meta: { sticky: "left", hideFromSettings: true },
  },
  {
    accessorKey: "price_per_month",
    header: "Monthly Price",
    type: "money",
  },
  {
    id: "all_request_sum",
    size: 220,
    minSize: 165,
    maxSize: 300,
    enableSorting: false,
    meta: { cellStyles: { p: 0 }, headerTitle: "All Requests" },
    accessorKey: "inline_metrics",
    type: "storageMetricsChart",
    header: (props) => {
      return ResourceMetricsHeaderCell({ ...props, defaultFrequency: "30d" });
    },
  },
  {
    accessorKey: "created_at",
    header: "Creation Date",
    type: "date",
  },
  {
    accessorKey: "all_time_spent",
    header: "Total Spend",
    type: "money",
  },
  {
    accessorKey: "requests_value",
    header: "All Requests",
    headerTooltip: "Overall requests for the last 7 days.",
    type: "numeralWithNA",
  },
  {
    accessorKey: "size",
    header: "Size",
    type: "byteToGib",
  },
  {
    accessorKey: "is_public",
    header: "Access",
    type: "accessMode",
  },
  { accessorKey: "region", header: "Region", type: "withCopy" },
  { accessorKey: "tags", header: "Tags", type: "tag", enableSorting: false },
  {
    accessorKey: "tags",
    header: "Smart Tags",
    id: "smart_tag",
    type: "smartTag",
    enableSorting: false,
  },
  {
    accessorKey: "issues",
    header: "Ticket Status",
    type: "jiraTicketStatus",
    enableSorting: false,
  },
];
